import { Scorm2004 } from "@/scorm/scorm_1_3/ScormModelIDs";
const scormTranslationMap = new Map([
    ["lesson_id", "lesson_id"],
    ["cmi.core.lesson_location", Scorm2004.LOCATION],
    ["cmi.core.lesson_status", Scorm2004.COMPLETION_STATUS],
    ["cmi.core.lesson_mode", Scorm2004.MODE],
    ["cmi.core.entry", Scorm2004.ENTRY],
    ["cmi.core.score.raw", Scorm2004.SCORE_RAW],
    ["cmi.core.score.min", Scorm2004.SCORE_MIN],
    ["cmi.core.score.max", Scorm2004.SCORE_MAX],
    ["cmi.core.exit", Scorm2004.EXIT],
    ["cmi.suspend_data", Scorm2004.SUSPEND_DATA]
]);
export function convertToScorm2004ModelId(modelId) {
    return scormTranslationMap.get(modelId);
}
